export default `
  :root {
      /* # Color Palette */
      --wuk-primary-color-pale: #fff1eb;
      --wuk-primary-color-light: #ffdfc8;
      --wuk-primary-color-normal: #ff8966;
      --wuk-primary-color-dark: #fc6437;
      --wuk-primary-color: #ff8966;

      --wuk-secondary-color-pale: #f6f1ff;
      --wuk-secondary-color-light: #dbcef3;
      --wuk-secondary-color-normal: #ae95da;
      --wuk-secondary-color-dark: #653dad;
      --wuk-secondary-color: var(--wuk-secondary-color-normal);
      --wuk-secondary-color-rgb: 174, 149, 218;

      --wuk-tertiary-color-pale: #f9f0e4;
      --wuk-tertiary-color-light: #f8d9c9;
      --wuk-tertiary-color-normal: #ffc6ad;
      --wuk-tertiary-color-dark: #f2a17d;
      --wuk-tertiary-color: var(--wuk-tertiary-color-normal);

      --wuk-context-color-1-rgb: 48, 38, 29;
      --wuk-context-color-1: #30261D;
      --wuk-context-color-2: #59514A;
      --wuk-context-color-3: #6E6761;
      --wuk-context-color-4: #837D77;
      --wuk-context-color-5: #B7B3B0;
      --wuk-context-color-6: #D6D4D2;
      --wuk-context-color-7: #EAE9E8;
      --wuk-context-color-8: #F5F4F4;

      /* # Font */
      --wuk-font-family: 'Montserrat';

      /* # Inputs */
      /* ## Specific Color assigns for inputs */
      --wuk-input-default-text-color-wuk: var(--wuk-context-color-4);
      --wuk-input-hover-text-color-wuk: var(--wuk-context-color-1);
      --wuk-input-hover-border-color-wuk: var(--wuk-secondary-color);
      --wuk-input-border-hover-color-wuk: var(--wuk-secondary-color);
      --wuk-dial-code-disabled-color: var(--wuk-context-color-7);
      --wuk-dial-code-mobile-background: var(--wuk-secondary-color);
      --wuk-range-text-color-wuk: var(--wuk-context-color-5);
      --wuk-help-text-color-wuk: var(--wuk-context-color-3);
      --wuk-dropdown-color-wuk: var(--wuk-context-color-4);
      --wuk-dropdown-color-filled-wuk: var(--wuk-context-color-5);
      --wuk-ruler-hover-background-color-wuk: var(--wuk-secondary-color-light);

      /* # Buttons */
      /* ## Specific Color assigns for inputs */
      --wuk-button-theme-primary-background: var(--wuk-tertiary-color-normal);
      --wuk-button-theme-primary-color: var(--wuk-context-color-1);
      --wuk-button-theme-primary-hover-background: var(--wuk-primary-color-normal);

      --wuk-button-theme-secondary-border: var(--wuk-tertiary-color);
      --wuk-button-theme-secondary-hover-background: var(--wuk-tertiary-color);
      --wuk-button-theme-secondary-hover-color: var(--wuk-context-color-1);

      --wuk-button-theme-tertiary-background: white;
      --wuk-button-theme-tertiary-color: var(--wuk-context-color-2);
      --wuk-button-theme-tertiary-hover-background: var(--wuk-primary-color);

      --wuk-button-theme-transparent-hover-background: var(--wuk-tertiary-color);
      --wuk-button-theme-transparent-disabled-color: var(--wuk-tertiary-color);

      --wuk-button-theme-text-background: transparent;
      --wuk-button-theme-text-color: var(--wuk-context-color-1);
      --wuk-button-theme-text-disabled-color: var(--wuk-context-color-1);

      /* # Carousel */
      --wuk-carousel-control-icon-color: black;
      --wuk-info-carousel-active-card-border-color: var(--wuk-secondary-color);
      --wuk-info-carousel-active-subtitle-color: var(--wuk-context-color-1);
      --wuk-paginated-carousel-slide-image-bg: var(--wuk-secondary-color);
      --wuk-info-carousel-text-hover: var(--wuk-secondary-color);

      /* #Input range */
      --wuk-range-thumb-border-color-wuk: var(--wuk-primary-color);
  }
`;
